import { FC } from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from 'react-share'
import cx from 'classnames'

import Icon, { Icons } from '../Icon'
import useMediaQuery from '../../hooks/useMediaQuery'

import * as SC from './styled'

export type AdsShareSocialNetworksProps = {
  className?: string
  title: string
  urlToShare: string
  titleSharedPage: string
}

const AdsShareSocialNetworks: FC<AdsShareSocialNetworksProps> = ({
  className,
  title,
  urlToShare,
  titleSharedPage,
}) => {
  const matches = useMediaQuery('(min-width: 768px)')
  return (
    <SC.AdsShareSocialNetworks
      className={cx('AdsShareSocialNetworks', className)}
    >
      {matches && <SC.Separator />}
      <SC.Wrapper>
        <SC.Title>{title}</SC.Title>
        <SC.WrapperIcons>
          <TwitterShareButton url={urlToShare} title={titleSharedPage}>
            <Icon icon={Icons.shareSocialTwitter} width={47} height={47} />
          </TwitterShareButton>

          <FacebookShareButton url={urlToShare}>
            <Icon icon={Icons.shareSocialFacebook} width={47} height={47} />
          </FacebookShareButton>

          <LinkedinShareButton url={urlToShare}>
            <Icon icon={Icons.shareSocialLinkedin} width={47} height={47} />
          </LinkedinShareButton>
        </SC.WrapperIcons>
      </SC.Wrapper>
      <SC.Separator />
    </SC.AdsShareSocialNetworks>
  )
}

export default AdsShareSocialNetworks
